import { nextArrow, prevArrow } from "@/global/slick-options";

jQuery( '.single-gallery-main' ).slick( {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    autoplay: false,
    rows: 0,
    asNavFor: '.single-gallery-nav'
} );

jQuery( '.single-gallery-nav' ).slick( {
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.single-gallery-main',
    autoplay: false,
    dots: false,
    fade: false,
    arrows: true,
    centerMode: true,
    rows: 0,
    centerPadding: '0',
    prevArrow,
    nextArrow
} );
